import {SurveyDefinitionModel} from "data/models/survey";
import {
  BestWordsChartComponent,
  HowToUseBestWordsChartTitle
} from "components/Survey/survey-sections-rendering-components/BestWordsComponents";
import ShowKeyMessageSurveyQuestionPage
  from "components/Survey/survey-question-pages/ShowKeyMessageSurveyQuestionPage";


export const WORDS_AND_MESSAGES: SurveyDefinitionModel = {
  id: "words-and-messages",
  surveyQuestions: [
    {
      id: "what-to-say",
      title: "What to say and how to say it",
      description: "The words you use—in writing or said verbally—are an important part of your brand.",
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "center",
        paragraphs: [
          "Your message is what you say or write about." +
          " Your tone of voice is how you say it or write it." +
          " Both what you say, and how you say it," +
          " should represent your unique brand and be appealing" +
          " to your ideal customers."
        ]
      },
    }, {
      id: "use-the-best-words",
      title: "Use the best words.",
      description: null,
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "left",
        paragraphs: [
          "The chart below will help you know what words" +
          " have the highest appeal for your ideal customer" +
          " and which conflict with their values.",
          BestWordsChartComponent,
          HowToUseBestWordsChartTitle,
          "The words at the top of the chart, with the longest green line next to them," +
          " are the words you should try to use the most." +
          " Use these words (or words that convey the same idea) when you talk" +
          " about your features and benefits.",
          "If you have any words at the bottom that have a red bar next to them," +
          " those are words to avoid! While those words may accurately describe your" +
          " product or service, there is something about them that is a turn-off for your prospects.",
        ]
      },
    },
    {
      id: "show-key-message",
      title: "Best brand messages",
      description: null,
      kind: "paragraphs",
      maxScreenWidth: "md",
      required: true,
      backButtonText: null,
      nextButtonText: null,
      options: {
        textAlignment: "left",
        paragraphs: [
          ShowKeyMessageSurveyQuestionPage
        ]
      },
    },
  ],
}
